import type { ReactNode } from 'react';

export const symbol_collections_bookmark: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-260h560v-560h-60v252q0 8.5-7.5 12.75T737-556l-54-33q-7.58-4-16.29-4-8.71 0-15.71 4l-54 33q-8 5-15.5.75T574-568v-252H260v560Zm0 60q-24 0-42-18t-18-42v-560q0-24 18-42t42-18h560q24 0 42 18t18 42v560q0 24-18 42t-42 18H260ZM140-80q-24 0-42-18t-18-42v-590q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v590h590q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q742.75-80 730-80H140Zm120-740v560-560Zm314 252q0 8.5 7.5 12.75T597-556l54-33q6.75-4 15.38-4 8.62 0 16.62 4l54 33q8 5 15.5.75T760-568q0 8.5-7.5 12.75T737-556l-54-33q-7.58-4-16.29-4-8.71 0-15.71 4l-54 33q-8 5-15.5.75T574-568Z"
		/>
	</svg>
);
